import React, {
  useEffect,
  useState,
  useContext,
} from 'react';
import { useHistory } from 'react-router';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import {
  Link,
  Typography,
} from '@material-ui/core';
import SimpleModal from '../SimpleModal';
import Button from '../Button';
import { AuthContext } from '../../contexts';
import {
  IS_CALLING_SELF,
  NO_AVANSER_LOGIN,
  NO_CALL_ACCESS,
  NO_CALLER_MOBILE_NUMBER,
  NO_ANSWERPOINT_DIALER,
} from '../../data';

const CallNotAllowedModal = (props) => {
  const {
    status,
    type,
    open,
    onClose,
  } = props;

  const { t } = useTranslation();
  const history = useHistory();
  const authContext = useContext(AuthContext);
  const { user } = authContext.state;

  const emailSupport = t('component.email-support', 'support@mhub.my');
  const translationParams = { type };

  const [modal, setModal] = useState({
    title: '',
    content: null,
    cta: onClose,
    ctaText: t('component.label.okay', 'Okay'),
  });

  useEffect(() => {
    if (status) {
      const defaultCTA = {
        cta: onClose,
        ctaText: t('component.label.okay', 'Okay'),
      };
      switch (status) {
        case NO_CALL_ACCESS:
        case NO_ANSWERPOINT_DIALER:
          setModal({
            title: NO_ANSWERPOINT_DIALER ? t('avanser.error.no_answer_point', 'You need Avanser dialer to use this feature.')
              : t('component.error.only_avail_in_website', 'This feature is only available on the mobile website.'),
            content: (
              <Typography>
                {t('avanser.error.call_is_not_allowed', 'Please access with your mobile device instead, or contact')}
                &nbsp;
                <Link href={`mailto:${emailSupport}`}>{emailSupport}</Link>
                &nbsp;
                {t('component.text.for_more_info', 'for more info')}
              </Typography>
            ),
            ...defaultCTA,
          });
          break;
        case NO_AVANSER_LOGIN:
          setModal({
            title: t('avanser.error.not_connected', 'You have not connected to your Avanser account.'),
            content: (
              <Typography>
                {t('avanser.error.not_connected_title', 'Connect your Avanser account in the')}
                &nbsp;
                <Link href="/settings/call">{t('component.text.settings_page', 'settings page')}</Link>
                &nbsp;
                {t('avanser.error.not_connected_subtitle', 'first. If you don’t have one, contact')}
                &nbsp;
                <Link href={`mailto:${emailSupport}`}>{emailSupport}</Link>
                &nbsp;
                {t('component.text.for_more_info', 'for more info')}
              </Typography>
            ),
            cta: () => history.push('/settings/call'),
            ctaText: t('component.label.go_to_settings_page', 'Go to settings page'),
          });
          break;
        case NO_CALLER_MOBILE_NUMBER:
          setModal({
            title: t('avanser.error.no_mobile_number_account', 'Your mobile number is required.'),
            content: (
              <Typography>
                {t(
                  'avaser.error.no_mobile_number_account_content',
                  'We notice that your account is not tie to any mobile number.'
                  + 'Kindly update and try again.',
                )}
              </Typography>
            ),
            ...defaultCTA,
          });
          break;
        case IS_CALLING_SELF:
          setModal({
            title: t('avanser.error.same_mobile_content', 'Same mobile number detected.'),
            content: (
              <Typography>
                {t('avanser.error.same_mobile_content_content', {
                  params: translationParams,
                  defaultValue: 'We notice that the {type} you are trying to call has the same mobile number as you.',
                })}
              </Typography>
            ),
            ...defaultCTA,
          });
          break;
        default:
          break;
      }
    }
  }, [
    status,
    history,
    type,
    onClose,
    user,
  ]);

  return (
    <SimpleModal
      title={modal.title}
      open={!!status && open}
      content={modal.content}
      onCancel={onClose}
      buttons={(
        <Button
          variant="contained"
          onClick={modal.cta}
        >
          { modal.ctaText }
        </Button>
      )}
    />
  );
};

CallNotAllowedModal.propTypes = {
  status: PropTypes.string,
  type: PropTypes.oneOf(['lead', 'customer']),
  open: PropTypes.bool,
  onClose: PropTypes.func,
};

CallNotAllowedModal.defaultProps = {
  status: '',
  type: 'lead',
  open: false,
  onClose: () => {},
};

export default CallNotAllowedModal;
